import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "phoneLink"
const PhoneLinkIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <title>{iconSource}</title>
          <path d="m20.123 7.7-1.002 1c1.803 1.8 1.803 4.6 0 6.5l1.002 1c2.503-2.3 2.503-6.1 0-8.5ZM18.02 9.8l-1.001 1c.5.7.5 1.6 0 2.3l1.001 1c1.201-1.2 1.201-3 0-4.3ZM14.015 1H4.003C2.9 1 2 1.9 2 3v18c0 1.1.901 2 2.003 2h10.012c1.101 0 2.002-.9 2.002-2V3c0-1.1-.9-2-2.002-2Zm0 19H4.003V4h10.012v16Z" />
        </svg>
      }
    </span>
  )
}
export default PhoneLinkIcon
